<template>
    <div>
        <pedidosreservados :idproduto="idprodutores" :descricao="descprores"></pedidosreservados>
        <div class="modal fade" id="mdestoqueproduto" tabindex="-1" role="dialog" aria-labelledby="mdestoqueproduto" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"><i class="fa fa-cubes"></i> Estoque do produto</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row" v-show="mostrar">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <span style="color: #666666; font-weight: 600;">{{idproduto}} - {{descricao}}</span>
                                </div>                                                                
                            </div>
                            <div v-if="lstestoques.length > 0" class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm table-hover">
                                        <thead class="thead-light">
                                            <tr style="font-weight: 600;">
                                                <th>Estoque:</th>
                                                <th>Disponível:</th>
                                                <th>Reservado:</th> 
                                                <th>Geral:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in lstestoques" v-bind:key="index">
                                                <td style="font-weight: 600;">{{ item.descricao }}</td>
                                                <td style="text-align: right; font-weight: 600;">
                                                    {{ parseInt(item.fator) > 0 ? item.formatado : mtdformatavalordecimal(parseFloat(item.quantidade), 3)}}
                                                </td>
                                                <td style="text-align: right; font-weight: 600;">
                                                    <i v-if="parseFloat(item.qtdreservada) > 0" class="fa fa-codepen btn-visualiza-reserva" @click.prevent="mtdvisualizarreservados()" title="Visualizar pedidos reservados"></i>
                                                    {{mtdformatavalordecimal(parseFloat(item.qtdreservada), 3)}}
                                                </td>                                                    
                                                <td style="text-align: right;">
                                                    <span class="badge badge-secondary badge-pill badge-item-estoque">
                                                        {{mtdformatavalordecimal(parseFloat(item.qtddisponivel), 3)}}
                                                    </span>
                                                </td>                                                    
                                            </tr>
                                            <tr v-if="lstestoques.length > 1" style="background: #e9ecef; border-top: 3px solid #6f7f8c; ">
                                                <td style="font-weight: 600;">TOTAIS</td>
                                                <td style="text-align: right; font-weight: 600;">
                                                    {{mtdformatavalordecimal(parseFloat(disponivel), 3)}}
                                                </td>
                                                <td style="text-align: right; font-weight: 600;">
                                                    {{mtdformatavalordecimal(parseFloat(reservado), 3)}}
                                                </td>                                                    
                                                <td style="text-align: right;">
                                                    <span class="badge badge-secondary badge-pill badge-item-estoque">
                                                        {{mtdformatavalordecimal(parseFloat(geral), 3)}}
                                                    </span>
                                                </td>                                             
                                            </tr>    
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else class="col-md-12" style="padding-bottom: 10px;">
                                <ul class="list-group">
                                    <li class="list-group-item lst-item-estoque text-center">
                                        <span>
                                            SEM ESTOQUE PARA VISUALIZAÇÃO
                                        </span>
                                    </li>
                                </ul>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal"><i class="fa fa-sign-out"></i> Fechar</a>
                    </div>
                </div>
            </div>
        </div>                
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
import Pedidosreservados from '../components/cmppedidosreservados'
export default {
    name: 'cmpvisualizadorestoque',
    components : {
        'pedidosreservados'   : Pedidosreservados,
    },
    props:[
                'idproduto',
                'descricao'
          ],
    data: function() {
        return {
            idprodutores        : '',
            descprores          : '',  
            mostrar             : false,//variável só pra esconder a visualização da div
            lstestoques         : [],
            disponivel          : 0,
            reservado           : 0,
            geral               : 0,
            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false
            }            
        };
    },
    methods: {
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },        
        mtdlistarestoque(){
            let vself       = this;
            let loader      = vself.$loading.show();
            let parametros  = [
                {parametro: 'op',               valor : 'listarestoque'},
                {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'idproduto',        valor : vself.idproduto},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
            retorno.then(function (response) {
                loader.hide();
                vself.lstestoques = response.data;
                if (vself.lstestoques.length > 1){
                    vself.geral               = 0;
                    for (let i = 0; i < vself.lstestoques.length; i++) {
                        vself.geral           = parseFloat(vself.geral) + parseFloat(vself.lstestoques[i].qtddisponivel);                    
                    }
                }                
                vself.mostrar     = true;  
            }).catch(function (response) {
                vself.mostrar     = false;  
                loader.hide();
            });
        },        
        mtdvisualizarreservados(){
            this.idprodutores   = this.idproduto;
            this.descprores     = this.descricao;
            $('#mdpedidosreservados').modal('show');
        }        
    },
    mounted: function() {
        let vself = this;
        $("#mdestoqueproduto").on('shown.bs.modal', function(){
            vself.mtdlistarestoque();
        });
        $("#mdestoqueproduto").on('hide.bs.modal', function(){
            vself.mostrar     = false;
            vself.lstestoques = [];
        });                        
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>
    .lst-item-estoque{
        padding: 5px 15px !important;
        font-weight: 700;
        color: #666666;
    }
    .badge-item-estoque{
        font-size: 14px!important;
    }
    #mdestoqueproduto{
        z-index: 2001!important;
    } 
    .btn-visualiza-reserva{
        cursor: pointer;
        float: left;
        margin-top: 5px; 
        transition: 0.2s;       
    } 
    .btn-visualiza-reserva:hover{
        filter: brightness(90%)!important;
        transition: 0.2s;       
    }            
</style>